import React from 'react';
import { Card, Badge, Image, ListGroup, Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalCreateConfiguration({ show, onHide, selectedFlow, handleConfirmCreate, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Excellent choice - Get started right away!')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className="mb-2">{t('Your selected Flow')}</h4>
                <div className="px-5 bg-light rounded p-4 mb-3">
                    <span className="text-muted fs-6">
                        {selectedFlow?.category &&
                            selectedFlow?.category === 'store' ? 'Marktplatz' :
                            selectedFlow?.category === 'shopsystem' ? 'Shop & Warenwirtschaft' :
                                selectedFlow?.category === 'other' ? 'Weitere Connectoren' :
                                    selectedFlow?.category
                        }
                    </span>
                    <h4 className="h5 mb-2 text-truncate-line-2 ">
                        {selectedFlow?.title ? selectedFlow?.title : ''}
                    </h4>
                    <span className="text-muted fs-6">
                        {selectedFlow?.description ? selectedFlow?.description : ''}
                    </span>
                    <ListGroup as="ul" bsPrefix="list-inline" className="mb-3 mt-2 text-muted fs-6">
                        {selectedFlow?.features && selectedFlow?.features.map((feature, index) => (
                            <ListGroup.Item as="li" bsPrefix="" key={index}>
                                <i className="fe fe-arrow-right"></i>
                                {feature}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
                <div className="pt-3">
                    <h4 className="mb-2">{t('Billing Summary')}</h4>
                    <div className="px-3 bg-light rounded p-3 mb-3">
                        <ListGroup variant="flush">
                            <ListGroup.Item className="d-flex justify-content-between align-items-center fs-6 text-muted">
                                <span>{t('Price')}</span>
                                <span>{selectedFlow?.price ? `${selectedFlow.price} €` : t('N/A')}</span>
                            </ListGroup.Item>
                            {selectedFlow?.discount && selectedFlow.discount > 0 ? (
                                <>
                                <ListGroup.Item className="d-flex justify-content-between align-items-center fs-6 text-muted">
                                    <span>{t('Discount')}</span>
                                    <span>
                                        {selectedFlow?.discount && selectedFlow.discount > 0
                                            ? `- ${selectedFlow.discount} €`
                                            : '0 €'}
                                    </span>
                                </ListGroup.Item>
                                </>
                            ) : null }
                            <ListGroup.Item className="d-flex justify-content-between align-items-center fw-bold fs-6 text-muted">
                                <span>{t('Total')}{' '}{t('excl. VAT')}</span>
                                <span>
                                    {selectedFlow?.price - selectedFlow?.discount > 0
                                        ? `${selectedFlow.price - selectedFlow.discount} € / ${t('Month')}`
                                        : t('for free')}
                                </span>
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                    <p className="text-muted small">
                        {t('By clicking Add with costs, you agree our terms and conditions. This cost will be added to your current subscription price.')}{' '}
                        {t('On your next renewal you’ll be charged')}{' '}{selectedFlow?.price - selectedFlow?.discount}{' '}€{' '}{t('excl. VAT for this Flow.')}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="primary" onClick={handleConfirmCreate} disabled={isLoadingButton}>
                    {isLoadingButton ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            {t('Add with costs')}
                        </>
                    ) : (
                        t('Add with costs')
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalCreateConfiguration;